import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

/**
 * Wizard step management controller for ITSM ticket creation.
 * Persists form state to server-side session so back navigation preserves values.
 *
 * Back links opt out of Turbo prefetch (data-turbo-prefetch="false"): a
 * hover prefetch carries the session cookie from BEFORE the save, and when it
 * finishes after the save its Set-Cookie overwrites the saved state.
 *
 * data-controller="support--ticket-wizard"
 * data-support--ticket-wizard-save-url-value="/support/tickets/wizard_state"
 */
export default class extends Controller {
  static targets = ["backLink"]
  static values = { saveUrl: String }

  connect() {
    this.boundInterceptBack = this.interceptBack.bind(this)
    this.backLinkTargets.forEach((link) => {
      link.addEventListener("click", this.boundInterceptBack)
    })
  }

  disconnect() {
    this.backLinkTargets.forEach((link) => {
      link.removeEventListener("click", this.boundInterceptBack)
    })
  }

  async interceptBack(event) {
    event.preventDefault()
    const link = event.currentTarget
    const form = this.element.querySelector("form")

    if (form && this.hasSaveUrlValue) {
      const formData = new FormData(form)
      await post(this.saveUrlValue, {
        body: formData,
        responseKind: "json",
      })
    }

    window.location.href = link.href
  }
}
